import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PolicySlug } from 'src/app/pages/legal/policy/shared/utils';
import { getPolicySlugFromRouteSlug } from 'src/app/pages/legal/policy/shared/utils';

import type { PolicyContentQuery, PolicyContentQueryVariables } from './api.graphql';
import { PolicyContent } from './api.graphql';

export type PolicyPageData = Omit<NonNullable<PolicyContentQuery['policyContent']>, 'slug'> & {
	slug: PolicySlug;
};

export async function getPolicyPageData(
	{ gql: { fetch } }: UtilityContext,
	routeSlug: string | undefined,
	{ countryCode, locale }: { countryCode: string; locale: string },
): Promise<PolicyPageData> {
	const slug = getPolicySlugFromRouteSlug(routeSlug);

	if (!slug) {
		throw new NotFoundError();
	}

	const { data } = await fetch<PolicyContentQuery, PolicyContentQueryVariables>({
		query: PolicyContent,
		variables: {
			slug,
			countryCode,
			locale,
		},
		rejectOnError: true,
	});
	if (!data.policyContent) {
		throw new NotFoundError();
	}
	return {
		...data.policyContent,
		slug,
	};
}
